import React, { FC, createContext, useState, useEffect } from 'react';
import { FeatureToggles } from 'Common/appshell_types/featureToggles';
import {
    FeatureTogglePayload,
    UPDATE_FEATURE_TOGGLE_EVENT_NAME,
    FeatureTogglesActions,
} from 'Client/WestwingEventHandler';

export const FeatureToggleContext = createContext<FeatureToggles>({} as FeatureToggles);
const { Provider, Consumer } = FeatureToggleContext;
export { Consumer as FeatureToggleConsumer };

export interface FeatureToggleProviderProps {
    value: FeatureToggles;
}

const FeatureToggleProvider: FC<FeatureToggleProviderProps> = ({ children, value }) => {
    const [ftState, setFtsState] = useState(value);

    useEffect(() => {
        if (window.ww && window.ww.events) {
            window.ww.events.subscribe(UPDATE_FEATURE_TOGGLE_EVENT_NAME, (data: FeatureTogglePayload) => {
                const { action, name } = data;
                const newState = { ...ftState };
                if (action === FeatureTogglesActions.ON && name) {
                    newState[name] = true;
                } else if (action === FeatureTogglesActions.OFF && name) {
                    newState[name] = false;
                }
                setFtsState(newState);
            });
        }
        // This should register the event only one time.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <Provider value={ftState}>{children}</Provider>;
};

export default FeatureToggleProvider;
